import { Chip, Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const NameChip = ({ fullName = '' }) => {
  // split fullName and grab the initials for first and last name, ignoring suffix if it is present
  const initials = fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');

  return (
    <Chip
      sx={{ textTransform: 'capitalize', maxWidth: 'fit-content' }}
      variant="outlined"
      avatar={
        <Avatar>{fullName !== '' ? initials : <PersonIcon sx={{ padding: '.15rem' }} />}</Avatar>
      }
      label={fullName ? fullName : 'No details available'}
    />
  );
};

export default NameChip;
